export enum TaxFiling {
    SINGLE = 'SINGLE',
    HEAD_OF_HOUSEHOLD = 'HEAD_OF_HOUSEHOLD',
    MARRIED_FILING_JOINTLY = 'MARRIED_FILING_JOINTLY',
    MARRIED_FILING_SEPARATELY = 'MARRIED_FILING_SEPARATELY',
}
